export const createWallet_metamask = [
    {
      title: "Cómo conectar tu wallet MetaMask en MyEtherWallet (MEW)",
      value: `
  1. **Accede a MyEtherWallet**  
     Ingresa a [MyEtherWallet](https://www.myetherwallet.com/) y haz clic en el botón negro que dice **"Acceder a mi wallet"** en la parte superior derecha de la página principal.
  
     ![Paso 1](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-1.png)
  
  2. **Selecciona método de conexión**  
     Aparecerá una ventana con distintas opciones para acceder.  
     Desplázate hacia abajo hasta encontrar la sección **"Browser extension"**.  
     Ahí verás las extensiones compatibles con MEW, como **Enkrypt** y **MetaMask**.
  
     ![Paso 2](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-3.png)
  
  3. **Conecta tu wallet MetaMask**  
     Haz clic sobre el ícono de **MetaMask**.  
     Se abrirá una ventana emergente de MetaMask para que elijas la cuenta que deseas conectar.  
     Selecciona tu cuenta y presiona **Conectar** para vincularla con MyEtherWallet.
  
     ![Paso 3](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-4.png)
  
  4. **Revisa los permisos**  
     Una vez conectada, MetaMask mostrará una solicitud para cambiar o confirmar la red.  
     Asegúrate de seleccionar la red correcta, como **Sepolia**.
  
     ![Paso 4](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-5.png)
  
  5. **Accede al panel de tu wallet**  
     Después de conectarte, verás el panel de tu wallet donde puedes revisar tu balance, interactuar con contratos y hacer swaps.
  
     ![Paso 5](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-6.png)
  
  6. **Cambia la red a Sepolia**  
     Desde el menú lateral, haz clic en el nombre de la red actual y selecciona la pestaña **TEST**, luego elige **Sepolia** para trabajar en red de pruebas.
  
     ![Paso 6](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-10.png)
  
7. **Panel principal con la red Sepolia conectada**  
   Ahora que has conectado correctamente tu wallet MetaMask y seleccionado la red de pruebas **Sepolia**, puedes ver tu panel principal de MyEtherWallet.  
   - En la parte superior derecha, se indica que estás conectado a la **Sepolia Testnet**.  
   - Tu **balance de SEP** (el token de prueba de Sepolia) aparece destacado tanto en la tarjeta del portafolio como en la sección principal.
   - Desde aquí, puedes consultar tu saldo, el valor de tu portafolio, explorar y enviar o recibir tokens de prueba, así como interactuar con contratos inteligentes en la red de pruebas.

   ![Panel principal de MyEtherWallet](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-11.png)

8. **Red de prueba AMOY y el mensaje de error**  
   Si vuelves a abrir el panel de selección de redes desde **"Networks"** y tratas de seleccionar la red de prueba **AMOY**, notarás que aparece el mensaje rojo:  
   **"It seems like you don’t have this network set up in MetaMask"**.  
   
   Esto ocurre porque la red AMOY **no está configurada todavía en tu MetaMask** y, a diferencia de otras redes, **no puede añadirse automáticamente desde MEW**. Por eso, aunque la opción esté visible, no se puede seleccionar directamente desde el menú de redes de MyEtherWallet.

   Para poder usar la testnet AMOY, **debes agregarla manualmente desde la extensión de MetaMask**.  
   
   En la siguiente actividad aprenderás paso a paso cómo agregar la red AMOY para poder interactuar con contratos y tokens en esa testnet.

   ![Error red AMOY no configurada](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/7-9.png)

  `
    }
  ];
  
  export default createWallet_metamask;
  